import React from 'react';

import serverApi from '../../../utils/serverApi';
import statesGetAllHocWrapper from '../../hoc/statesGetAllHoc';
import manualStateLocateRequests from './manualStateLocateRequests';

class StateCallTicketDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedState: '',
      locateRequestUrl: '',
      isLocateRequestLoading: false,
      locateRequestError: null,
    };
  }

  componentDidMount() {
    this.props.statesGetAllHoc.getAll();
  }

  getStatesWithManualStates = (states) => {
  const stateNameOverrides = manualStateLocateRequests.stateNameOverrides || {};
  const manualStates = manualStateLocateRequests.states || [];

  const stateList = states && Array.isArray(states)
    ? states.map((state) => {
        const abbreviation = state.abbreviation
          ? state.abbreviation.toLowerCase()
          : '';

        const overrideName = stateNameOverrides[abbreviation];

        return {
          ...state,
          name: overrideName || state.name,
        };
      })
    : [];

  manualStates.forEach((manualState) => {
    const alreadyExists = stateList.some(
      (state) =>
        state.abbreviation &&
        state.abbreviation.toLowerCase() === manualState.abbreviation.toLowerCase()
    );

    if (!alreadyExists) {
      stateList.push(manualState);
    }
  });

  stateList.sort((a, b) => {
    const nameA = a.name ? a.name.toUpperCase() : '';
    const nameB = b.name ? b.name.toUpperCase() : '';

    if (nameA < nameB) {
      return -1;
    }

    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  return stateList;
};

  getManualLocateRequest = (stateAbbreviation) => {
    if (!stateAbbreviation) {
      return null;
    }

    const locateRequests = manualStateLocateRequests.locateRequests || {};

    return locateRequests[stateAbbreviation.toLowerCase()] || null;
  };

  getLocateRequestUrl = (response) => {
    const locateRequest =
      response &&
      response.locateRequest &&
      response.locateRequest.length
        ? response.locateRequest[0]
        : null;

    return locateRequest && locateRequest.oneCallTicketEntry1
      ? locateRequest.oneCallTicketEntry1
      : '';
  };

  handleChange = (e) => {
    const selectedState = e.target.value;

    this.setState({
      selectedState,
      locateRequestUrl: '',
      locateRequestError: null,
    });

    if (!selectedState) {
      return;
    }

    this.setState({ isLocateRequestLoading: true }, () => {
      serverApi.statesGetLocateRequest(selectedState)
        .then((response) => {
          const manualLocateRequest = this.getManualLocateRequest(selectedState);
          const locateRequestResponse = manualLocateRequest || response;
          const locateRequestUrl = this.getLocateRequestUrl(locateRequestResponse);

          this.setState({
            locateRequestUrl,
            isLocateRequestLoading: false,
            locateRequestError: null,
          });
        })
        .catch((error) => {
          const manualLocateRequest = this.getManualLocateRequest(selectedState);

          const locateRequestUrl = manualLocateRequest
            ? this.getLocateRequestUrl(manualLocateRequest)
            : '';

          this.setState({
            locateRequestUrl,
            isLocateRequestLoading: false,
            locateRequestError: locateRequestUrl ? null : error,
          });
        });
    });
  };

  handleButtonClick = () => {
    const { locateRequestUrl } = this.state;

    if (locateRequestUrl) {
      window.open(locateRequestUrl, '_blank', 'noopener,noreferrer');
    }
  };

  render() {
    const {
      states,
      isLoading,
      error,
    } = this.props.statesGetAllHoc;

    const {
      selectedState,
      locateRequestUrl,
      isLocateRequestLoading,
      locateRequestError,
    } = this.state;

    const stateOptions = this.getStatesWithManualStates(states);

    return (
      <React.Fragment>
        <select
          className="form-control"
          value={selectedState}
          onChange={this.handleChange}
          disabled={isLoading}
        >
          <option value="">
            {isLoading ? 'Loading states...' : 'Select a state'}
          </option>

          {stateOptions.map((state) => (
            <option
              key={state.id}
              value={state.abbreviation.toLowerCase()}
            >
              {state.name}
            </option>
          ))}
        </select>

        {error && (
          <p className="text-danger">
            Unable to load states.
          </p>
        )}

        {locateRequestError && (
          <p className="text-danger">
            Unable to load locate request.
          </p>
        )}

        <button
          className="btn"
          type="button"
          disabled={!locateRequestUrl || isLocateRequestLoading}
          onClick={this.handleButtonClick}
        >
          {isLocateRequestLoading ? 'Loading...' : 'Request Ticket Electronically'}
        </button>
      </React.Fragment>
    );
  }
}

export default statesGetAllHocWrapper(StateCallTicketDropdown);



// WEBPACK FOOTER //
// ./src/components/common/stateCallTicketDropdown/StateCallTicketDropdown.js